import { render } from "./threePieced.vue?vue&type=template&id=46807313&scoped=true"
import script from "./threePieced.vue?vue&type=script&lang=js"
export * from "./threePieced.vue?vue&type=script&lang=js"

import "./threePieced.vue?vue&type=style&index=0&id=46807313&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46807313"]])

export default __exports__